export default "__VITE_ASSET__Z_ex7EqZ__"